export const display = {
  title: 'Display',
  titleEN: 'Display',
  description: 'Mynet.com\'da ana sayfa ve içerik sayfalarında bulunan banner çalışmalarıdır.',
  descriptionEN: 'Banner advertisements found on the main page and content pages of Mynet.com.',
  tabs: [
    {
      id: 1,
      title: 'Display Yayınlar',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          image: 'https://srv-cdn.onedio.com/store/b5b4275dd5e5afe50bc5c1d2446206ec44550c281dce69a9027071daaa2f3137.png',
          category: 'Masthead',
          modal: 'image',
          modalTitle: 'Masthead'
        },
        {
          id: 2,
          image: 'https://srv-cdn.onedio.com/store/5ad14a12419462a97041dc8473624bd1f9f2463856c5b380b35a608ac086cdad.png',
          category: 'Manşet Altı Bant',
          modal: 'image',
          modalTitle: 'Manşet Altı Bant'
        },
        {
          id: 3,
          image: 'https://srv-cdn.onedio.com/store/cf2c42e3c33691218cbe12369cd400139b1c9a58c19132adfa343e225f38953b.png',
          category: 'Preroll',
          modal: 'image',
          modalTitle: 'Preroll'
        },
        {
          id: 4,
          image: 'https://srv-cdn.onedio.com/store/afeeb9966998b74ea536f54a8341d836c23db3917a68e6d00debeebfaa09f758.png',
          category: 'Desktop Pageskin',
          modal: 'image',
          modalTitle: 'Desktop Pageskin'
        },
        {
          id: 5,
          image: 'https://srv-cdn.onedio.com/store/c618939d94add9234aecc6995df70b09468ea3cf048985e0c98b6758d9352738.png',
          category: 'Desktop Full Pageskin',
          modal: 'image',
          modalTitle: 'Desktop Full Pageskin'
        },
        {
          id: 6,
          image: 'https://srv-cdn.onedio.com/store/97139464a9625633166d27fce83fb728daa70e7885cd5c7b5a677eb12ac4c72a.png',
          category: '320x250',
          modal: 'image',
          modalTitle: '320x250'
        }
      ]
    },
    {
      id: 2,
      title: 'Data',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          image: 'https://srv-cdn.onedio.com/store/b43f23e1654a1e1b5970157336300430ec3fe7621005229221faf421aac53e3e.png',
          modal: 'image',
          modalTitle: 'Data',
        }
      ]
    }
  ],
  egTabs: [
    {
      id: 1,
      title: 'Display Advertising',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          image: 'https://srv-cdn.onedio.com/store/b5b4275dd5e5afe50bc5c1d2446206ec44550c281dce69a9027071daaa2f3137.png',
          category: 'Masthead',
          modal: 'image',
          modalTitle: 'Masthead'
        },
        {
          id: 2,
          image: 'https://srv-cdn.onedio.com/store/5ad14a12419462a97041dc8473624bd1f9f2463856c5b380b35a608ac086cdad.png',
          category: 'Below Headline Banner',
          modal: 'image',
          modalTitle: 'Below Headline Banner'
        },
        {
          id: 3,
          image: 'https://srv-cdn.onedio.com/store/cf2c42e3c33691218cbe12369cd400139b1c9a58c19132adfa343e225f38953b.png',
          category: 'Preroll',
          modal: 'image',
          modalTitle: 'Preroll'
        },
        {
          id: 4,
          image: 'https://srv-cdn.onedio.com/store/afeeb9966998b74ea536f54a8341d836c23db3917a68e6d00debeebfaa09f758.png',
          category: 'Desktop Pageskin',
          modal: 'image',
          modalTitle: 'Desktop Pageskin'
        },
        {
          id: 5,
          image: 'https://srv-cdn.onedio.com/store/c618939d94add9234aecc6995df70b09468ea3cf048985e0c98b6758d9352738.png',
          category: 'Desktop Full Pageskin',
          modal: 'image',
          modalTitle: 'Desktop Full Pageskin'
        },
        {
          id: 6,
          image: 'https://srv-cdn.onedio.com/store/97139464a9625633166d27fce83fb728daa70e7885cd5c7b5a677eb12ac4c72a.png',
          category: '320x250',
          modal: 'image',
          modalTitle: '320x250'
        }
      ]
    },
    {
      id: 2,
      title: 'Data',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          image: 'https://srv-cdn.onedio.com/store/b43f23e1654a1e1b5970157336300430ec3fe7621005229221faf421aac53e3e.png',
          modal: 'image',
          modalTitle: 'Data',
        }
      ]
    }
  ]
}
